import { Box, styled } from '@mui/material';

const getBoxSize = (
  width?: string | number,
  height?: string | number,
  padding?: string,
) => {
  return `
    ${
      width ? `width: ${typeof width === 'number' ? width + 'px' : width};` : ''
    }
    ${
      height
        ? `height: ${typeof height === 'number' ? height + 'px' : height};`
        : ''
    }
    ${padding ? `padding: ${padding};` : ''}
  `;
};

export const LayoutPanelWrapper = styled(Box)(
  ({ $width, $height, $padding, $showBorder }) => `
    display: flex;
    flex-direction: column;
    ${getBoxSize($width, $height, $padding)}
    background-color: white;
    ${
      $showBorder &&
      `
        border-radius: 16px;
        box-shadow: 0px 2px 22px 0px rgba(0,0,0,.12);
      `
    }
  `,
);

export const LayoutPanelHeaderWrapper = styled(Box)(
  ({ theme, $height, $padding, $showBottomBorder, $isSecondHeader }) => `
    display: flex;
    align-items: center;
    ${!$isSecondHeader ? 'justify-content: space-between;' : ''}
    ${getBoxSize('100%', $height, $padding)}
    border-bottom: ${
      $showBottomBorder
        ? `1px solid ${theme.colorPalette.neutral.surface.surface6}`
        : 'none'
    };
  `,
);

export const LayoutPanelContentContainerWrapper = styled(Box)(
  ({ $padding }) => `
    flex: 1;
    ${getBoxSize('100%', undefined, $padding)}
    display: flex;
    overflow: hidden;
  `,
);

export const LayoutPanelLeftSideBarWrapper = styled(Box)(
  ({ theme, $width, $padding, $showRightBorder }) => `
    flex: 0 0 ${$width}px;
    ${getBoxSize($width, '100%', $padding)}
    border-right: ${
      $showRightBorder
        ? `1px solid ${theme.colorPalette.neutral.surface.surface6}`
        : 'none'
    };
  `,
);

export const LayoutPanelRightSideBarWrapper = styled(Box)(
  ({ theme, $width, $padding, $showLeftBorder }) => `
    flex: 0 0 ${$width}px;
    ${getBoxSize($width, '100%', $padding)}
    border-left: ${
      $showLeftBorder
        ? `1px solid ${theme.colorPalette.neutral.surface.surface6}`
        : 'none'
    };
  `,
);

export const LayoutPanelContentWrapper = styled(Box)(
  ({ $padding }) => `
    flex: 1;
    ${getBoxSize(undefined, '100%', $padding)}
    min-width: 0;
  `,
);
